import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../environments/environment";


@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private AUTH_API: string;

    constructor(private http: HttpClient) {
        this.AUTH_API = `${environment.apiUrl}/auth/`;
    }

    async login(email: string, password: string): Promise<any> {
        return await this.http.post<any>(this.AUTH_API + 'sign-in', {email, password}).toPromise();
    }

    async profile(): Promise<any> {
        return await this.http.post<any>(this.AUTH_API + 'profile', {}, {}).toPromise();
    }

    async checkingSubscription(): Promise<any> {
        return await this.http.post<any>(this.AUTH_API + 'active-subscription', {}, {}).toPromise();
    }

    async register(fullName: string, email: string, password: string, referredBy: string, mobileNumber: string): Promise<any> {
        let roles = ['user'];
        return await this.http.post(this.AUTH_API + 'sign-up',
            {
                fullName,
                password,
                email,
                referredBy,
                roles,
                mobileNumber,
            }).toPromise();
    }

    async forgotPassword(email: string): Promise<any> {
        return await this.http.get(this.AUTH_API + 'reset-password/' + email).toPromise();
    }

    async resetPassword(email: string, password: string, confirmPassword: string, token: string): Promise<any> {
        return await this.http.post(this.AUTH_API + 'reset-password', {
            email, password, confirmPassword, token
        }).toPromise();
    }

    async updatePassword(
        oldPassword: string,
        password: string,
        email: string
    ): Promise<any> {
        return this.http.post(this.AUTH_API + 'update-password', {password}).toPromise();
    }
}
